import React from 'react';

import {StringIDFolder} from 'constants/FolderConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import APIUtil from 'util/APIUtil';

import {ProjectsListingFolder, ProjectsListingProject} from './ProjectsListing';
import SourceSidepanelItem from './SourceSidepanelItem';
import TopLevelFolderSidepanelItem from './TopLevelFolderSidepanelItem';

interface ProjectListProps {
  finderId: string;
  openResult: (rootFolder: StringIDFolder) => void;
  items: Array<ProjectsListingProject | ProjectsListingFolder>;
  areProjectsLoading: boolean;
}

export default function ProjectList(props: ProjectListProps): JSX.Element {
  if (props.areProjectsLoading) {
    return <CenteredHorizontalThrobber />;
  } else if (props.items.length === 0) {
    return (
      <div
        className="sidepanel-fadedMessage"
        {...getTestProps({component: 'ProjectList', element: 'emptyMessage'})}
      >
        None found.
      </div>
    );
  }
  return (
    <div>
      {props.items.map((item: ProjectsListingProject | ProjectsListingFolder) =>
        APIUtil.isSource(item.id) ? (
          <SourceSidepanelItem
            finderId={props.finderId}
            key={item.id}
            openResult={props.openResult}
            showCreator={true}
            showOwner={false}
            showStar={true}
            source={item as ProjectsListingProject}
            isChild={false}
          />
        ) : (
          <TopLevelFolderSidepanelItem
            key={item.id}
            finderId={props.finderId}
            isCompact={false}
            isListing={true}
            openResult={props.openResult}
            folder={item as ProjectsListingFolder}
            isChild={false}
          />
        )
      )}
    </div>
  );
}
